import { ServiceFetch } from '../service-fetch'

export default class CustomerTierModel extends ServiceFetch {
    generateCustomerTierLastCode = (data) => this.authFetch({
        url: 'customer-tier/generateCustomerTierLastCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerTierBy = (data) => this.authFetch({
        url: 'customer-tier/getCustomerTierBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerTierByCode = (data) => this.authFetch({
        url: 'customer-tier/getCustomerTierByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    checkDuplicateCustomerTier = (data) => this.authFetch({
        url: 'customer-tier/checkDuplicateCustomerTier',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateCustomerTierBy = (data) => this.authFetch({
        url: 'customer-tier/updateCustomerTierBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateMaintenceCustomerTierBy = (data) => this.authFetch({
        url: 'customer-tier/updateMaintenceCustomerTierBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    insertCustomerTier = (data) => this.authFetch({
        url: 'customer-tier/insertCustomerTier',
        method: 'POST',
        body: JSON.stringify(data),
    })

    deleteCustomerTierByCode = (data) => this.authFetch({
        url: 'customer-tier/deleteCustomerTierByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
    
    approveCustomerTierBy = (data) => this.authFetch({
        url: 'customer-tier/approveCustomerTierBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    runCustomerTierMaintenance = (data) => this.authFetch({
        url: 'customer-tier/runCustomerTierMaintenance',
        method: 'POST',
        body: JSON.stringify(data),
    })
}